<template>
  <div>
    <keep-alive>
      <router-view name="prepend" />
    </keep-alive>
    <keep-alive>
      <router-view />
    </keep-alive>
    <keep-alive>
      <router-view name="append" />
    </keep-alive>
  </div>
</template>

<script>
import csButton from "@/components/campos/csButton.vue";
import { mapActions } from "vuex";
import {isSerasa} from './constants'
export default {
  name: "App",
  components: {
    csButton,
  },
  methods: {
    ...mapActions(["setCurrentTheme"]),
  },
  mounted() {
    this.$nextTick(() => {
      if (isSerasa) {
        this.setCurrentTheme("serasa");
      }
    });
  },
};
</script>
